var _defs, _g, _path, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_501",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.129
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2350",
    "data-name": "Rectangle 2350",
    width: 42,
    height: 42,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2345",
    "data-name": "Rectangle 2345",
    width: 27.295,
    height: 14.828,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2346",
    "data-name": "Rectangle 2346",
    width: 5.288,
    height: 4.429,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2347",
    "data-name": "Rectangle 2347",
    width: 5.289,
    height: 4.429,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2348",
    "data-name": "Rectangle 2348",
    width: 5.289,
    height: 4.43,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5420",
    "data-name": "Group 5420",
    transform: "translate(-838 -569)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 838, 569)",
    filter: "url(#Ellipse_501)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_501-2",
    "data-name": "Ellipse 501",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5392",
    "data-name": "Group 5392",
    transform: "translate(847 575.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5391",
    "data-name": "Group 5391",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5390",
    "data-name": "Group 5390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5389",
    "data-name": "Group 5389",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14581",
    "data-name": "Path 14581",
    d: "M42,21A21,21,0,1,1,21,0,21,21,0,0,1,42,21",
    fill: "#003165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14582",
    "data-name": "Path 14582",
    d: "M64.3,84.935a9.017,9.017,0,0,1-2.176-17.767,13.817,13.817,0,1,0,10.464,13.4c0-.343-.016-.677-.041-1.011A9.015,9.015,0,0,1,64.3,84.935",
    transform: "translate(-39.285 -58.331)",
    fill: "#ffa625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5379",
    "data-name": "Group 5379",
    transform: "translate(6.011 21.23)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5378",
    "data-name": "Group 5378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5377",
    "data-name": "Group 5377",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14583",
    "data-name": "Path 14583",
    d: "M74.871,168.17a9.053,9.053,0,0,1-5.028,4.784,12.818,12.818,0,0,1-22.226-.752,13.815,13.815,0,0,0,27.3-3.02c0-.343-.016-.677-.041-1.011",
    transform: "translate(-47.617 -168.17)",
    fill: "#ffa625"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14584",
    "data-name": "Path 14584",
    d: "M168.895,119.92l1.01,2.048,2.259.327-1.634,1.594.385,2.249-2.02-1.06-2.021,1.06.387-2.249-1.634-1.594,2.26-.327Z",
    transform: "translate(-144.718 -104.781)",
    fill: "#ffa625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5382",
    "data-name": "Group 5382",
    transform: "translate(20.908 16.929)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5381",
    "data-name": "Group 5381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5380",
    "data-name": "Group 5380",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14585",
    "data-name": "Path 14585",
    d: "M170.559,136.251a3.053,3.053,0,0,1-.31.019,2.177,2.177,0,0,1-2.237-2.169l-.126.258-2.26.327,1.634,1.594-.387,2.249,2.021-1.06,2.02,1.06-.385-2.249Z",
    transform: "translate(-165.627 -134.101)",
    fill: "#ffa625"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14586",
    "data-name": "Path 14586",
    d: "M203.743,47.072l1.01,2.044,2.259.329-1.635,1.594.386,2.249-2.02-1.061-2.019,1.061.385-2.249-1.635-1.594,2.259-.329Z",
    transform: "translate(-175.167 -41.129)",
    fill: "#ffa625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5385",
    "data-name": "Group 5385",
    transform: "translate(25.308 7.73)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5384",
    "data-name": "Group 5384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5383",
    "data-name": "Group 5383",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14587",
    "data-name": "Path 14587",
    d: "M205.409,63.382c-.1.008-.2.019-.311.019a2.175,2.175,0,0,1-2.236-2.17l-.128.257-2.259.329,1.635,1.594-.385,2.249,2.019-1.061,2.02,1.061-.386-2.249Z",
    transform: "translate(-200.475 -61.231)",
    fill: "#ffa625"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14588",
    "data-name": "Path 14588",
    d: "M239.227,100.929l1.01,2.046,2.258.326-1.634,1.594.386,2.25-2.021-1.064-2.021,1.064.387-2.25-1.634-1.594,2.259-.326Z",
    transform: "translate(-206.172 -88.188)",
    fill: "#ffa625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5388",
    "data-name": "Group 5388",
    transform: "translate(29.787 14.528)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5387",
    "data-name": "Group 5387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5386",
    "data-name": "Group 5386",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14589",
    "data-name": "Path 14589",
    d: "M240.892,117.237a2.677,2.677,0,0,1-.311.019,2.177,2.177,0,0,1-2.237-2.169l-.127.259-2.258.326,1.634,1.594-.387,2.25,2.021-1.064,2.021,1.064-.386-2.25Z",
    transform: "translate(-235.959 -115.087)",
    fill: "#ffa625"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightMode);
export default __webpack_public_path__ + "static/media/night-mode.827c92b4ec016a27f34fe6c69211708e.svg";
export { ForwardRef as ReactComponent };